module.exports = __webpack_public_path__ + "5c114213/img/rename-icon.de4e673d.svg";